var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrap",staticClass:"wrap"},[_c('div',{ref:"boxdom",staticClass:"box"},[_c('div',{ref:"marquee",staticClass:"marquee"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('div',{ref:"copy",staticClass:"copy"})]),_vm._v(" "),_c('div',{ref:"node",staticClass:"node"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a4834aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/hospital/marquee.vue
// module id = null
// module chunks = 